import './PreviewSections';
function PreviewSectionItems(props) {
    let SectionList = props.sectionInfo.map ((cart, idx) =>
    {    
        return ( 
            <div className={"section " + (cart.className)} key={idx}>
                <div className="section_desc">
                    <div className="title-desc">
                        <div className="title">
                            {cart.title}
                        </div>
                        <div className="text">
                            {cart.text1}
                        </div>
                        <div className="text">
                            {cart.text2}
                        </div>
                    </div>
                </div>
                <div className="section_pic">
                    <img loading="lazy" className="pic" src= {cart.src} alt= {cart.alt} ></img>
                </div>
            </div>
        )
    });

return (
    <div className="preview-section-items">{SectionList}</div>
)}
export default PreviewSectionItems;